import inframarkLogo from "../../assets/inframark-logo.png";
import {
  StyledAuthFooter,
  StyledInframarkFooterLogo,
} from "./AuthPageLayout.styles";

export default function AuthPageFooter() {
  return (
    <StyledAuthFooter>
      <StyledInframarkFooterLogo src={inframarkLogo} alt="Inframark Logo" />
    </StyledAuthFooter>
  );
}
